import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchDataForCatalogPage } from '@/redux/modules/catalogPage';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch } = store;
    const catalogId = params.catalogId;
    return dispatch(fetchDataForCatalogPage(catalogId));
};
